import { getPayzeProviders, downloadPayzeProviderCsv } from '../services/napi';
import {
  PAYZE_PROVIDER_FETCH_SUCCESS,
  DOWNLOAD_PAYZE_PROVIDER_SUCCESS
} from '../constant/actionType';

export function fetchPayzeProviders() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await getPayzeProviders(projectId);
      dispatch({
        data: response.data.transactions,
        type: PAYZE_PROVIDER_FETCH_SUCCESS
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function downloadPayzeProvider() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await downloadPayzeProviderCsv(projectId);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `payzeProvider.csv`);
    document.body.appendChild(link);
    link.click();

    dispatch({
      data: response.data,
      type: DOWNLOAD_PAYZE_PROVIDER_SUCCESS
    });
  };
}
